import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Device, DeviceHistory, SubscribeSerialNumber, SubscribeSerialNumbers, UnsubscribeSerialNumber } from 'src/app/models/device/device.model';
import { MaintenanceHistory } from 'src/app/models/maintenance/maintenance.model';
import { AuthService } from '../../authentication/auth.service';
import { BaseApiService } from '../../base-api.service';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';

@Injectable()
export class RestDeviceService extends BaseApiService {

  constructor(httpClient: HttpClient,
    translate : TranslateFirebaseService,
    private authService : AuthService) {
    super(httpClient, translate);
  }

   //DEVICE APIs

  deleteDevice(id: string) : Observable<any>{
    return this.httpClient.delete(super.getUpsApiHost() + "Devices/" + id, {headers : this.authService.upsHttpHeaders});
  }

  createDevice(device: Device): Observable<Device> {
    return this.httpClient.post<Device>(super.getUpsApiHost() + "Devices", device, {headers : this.authService.upsHttpHeaders});
  }

  updateDevice(device: Device) {
    return this.httpClient.put(super.getUpsApiHost() + "Devices/" + device.id, device, {headers : this.authService.upsHttpHeaders});
  }

  getUserDeviceList() : Observable<Device[]>{
    return this.httpClient.get<Device[]>(super.getUpsApiHost() + "Devices", { headers: this.authService.upsHttpHeaders });
  }

  getDevice(id: string) : Observable<Device>{
    return this.httpClient.get<Device>(super.getUpsApiHost() + "Devices/" + id);
  }

  downloadDocument(docId: number) : Observable<any> {
    return this.httpClient.get<any>(super.getUpsApiHost() + "Documents/" + docId + "/file");
  }

  getDeviceHistoryByDeviceId(deviceId: string): Observable<DeviceHistory[]> {
    return this.httpClient.get<DeviceHistory[]>(super.getUpsApiHost() + 'Devices/history/' + deviceId, {headers: this.authService.upsHttpHeaders})
  }

  getDeviceMaintenanceHistoryById(id: number): Observable<MaintenanceHistory> {
    return this.httpClient.get<MaintenanceHistory>(super.getUpsApiHost() + 'MaintenanceHistory/' + id , {headers: this.authService.upsHttpHeaders})
  }

  getDeviceInstallationHistoryById(id: number): Observable<MaintenanceHistory> {
    return this.httpClient.get<MaintenanceHistory>(super.getUpsApiHost() + 'InstallationHistory/' + id , {headers: this.authService.upsHttpHeaders})
  }

  subscribeSerialNumbers(subscribeSerialNumbers : SubscribeSerialNumbers) : Observable<any> {
    return this.httpClient.post<any>(super.getUpsApiHost() + 'Notification/SubscribeSerialNumbers', subscribeSerialNumbers, { headers: this.authService.upsHttpHeaders});
  }

  subscribeSerialNumber(subscribeSerialNumber : SubscribeSerialNumber) : Observable<any> {
    return this.httpClient.post<any>(super.getUpsApiHost() + 'Notification/SubscribeSerialNumber', subscribeSerialNumber, { headers: this.authService.upsHttpHeaders});
  }

  unsubscribeSerialNumber(unsubscribeSerialNumber : UnsubscribeSerialNumber) : Observable<any> {
    return this.httpClient.post<any>(super.getUpsApiHost() + 'Notification/UnsubscribeSerialNumber', unsubscribeSerialNumber, { headers: this.authService.upsHttpHeaders});
  }

}
